import { setCookie, getCookie } from '../functions';

document.addEventListener('DOMContentLoaded', function () {
    const disclaimer = document.querySelector('.disclaimer');

    if (!disclaimer) return;

    if (!getCookie('disclaimerShown')) {
        disclaimer.classList.remove('is-hidden');
        disclaimer.classList.add('is-active');

        setTimeout(() => {
            disclaimer.classList.remove('is-active');
            disclaimer.classList.add('is-hidden');
            setCookie('disclaimerShown', 'true', 365);
        }, 10000);
    }
});
